import { iphoneGolfStore } from '../../link-actions';
import { getPromo } from '../../promos';

import {PromoBestWayToTry, PromoMidSection} from '../promoMidSection';

import Carousel from "react-multi-carousel";
import AnalysisSection from "../AnalysisSection";
import ReplaySection from "../ReplaySection";
import AutoPauseSection from "../AutoPauseSection";
import CastSection from "../CastSection";
import AutoSaveSection from "../AutoSaveSection";
import BottomCallToAction from "../BottomCallToAction";
import LoopExplainerSection from "../LoopExplainerSection";


export const GolfBase = (props) => {
    let sportKey = "golf";
    const promo = getPromo(sportKey);

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        }
    };
    return (<div>
            {props.banner}
            
        <AnalysisSection
            headline="Real-time swing analysis"
            subHeading="Improve quickly with instant feedback after every swing."
            analysers={[
                { src: "./assets/img/golf/analyze_spine_angle_good.png", caption: "Spine angle" },
                { src: "./assets/img/golf/analyze_trail_arm_good.png", caption: "Flying elbow" },
                { src: "./assets/img/golf/analyze_hip_slide_bad.png", caption: "Hip slide" },
                { src: "./assets/img/golf/analyze_head_track_bad.png", caption: "Head track" },
                { src: "./assets/img/golf/analyze_hand_path_bad.png", caption: "Hand path" },
                { src: "./assets/img/golf/analyze_spine_tilt_good.png", caption: "Spine tilt" },
                { src: "./assets/img/golf/analyze_takeaway_bad.png", caption: "Takeaway" },
                { src: "./assets/img/golf/analyze_arm_angle_good.png", caption: "Arm angle", showLg: false },
                { src: "./assets/img/golf/analyze_point_track.png", caption: "Point track" }
            ]}
        />
        
        <ReplaySection headline="Slow-motion instant replays" subHeading="Simply take a swing, wait for the delay, and watch the replay. All hands free." image="/assets/img/golf/replay_compare.png" />

        <AutoPauseSection headline="Auto-pause at takeaway, top, and impact" subHeading="Pause the replay without touching your phone."
            imageLeft={{src: "/assets/img/golf/auto_pause_section_settings.png", alt: "Configure auto-pause", caption: "Configure pause frame and duration.  The replay will continue once the duration is over."}}
            imageRight={{src: "/assets/img/golf/auto_pause_section_top.png", alt: "Auto-pause at key frames", caption: "Key frames are shown on the timeline so you can easily move to important moments."}}
        />


        <PromoMidSection promo={promo} />

        <CastSection headline="Cast replay to tablet or laptop" subHeading="Optionally connect a second device to watch and analyze on a bigger screen, at your feet." images={[
            {src: "./assets/img/driving_range_pov.png", alt: "Watch replay at your feet"},
            {src: "./watch_at_feet.png", alt: "Watch replay at your feet"}
        ]} />

        <AutoSaveSection headline="Auto-save every swing" subHeading="All shots are individually saved, so you can re-watch them with a single tap." image="/assets/img/golf/sessionlib.png" />


          <section className="atf-section-padding" style={{ paddingTop: "40px", paddingBottom: "40px" }}>
              <div className="container">
                  <div className="row justify-content-center" style={{backgroundColor: "yellowgreen"}}>
                      <div className="col-12 align-self-center text-center" >
                          <div style={{ margin: '20px 10px 20px 10px', padding: '10px', background:"white"}}>
                              <h2 style={{ display: "inline-block", fontSize: '34px', lineHeight:"1.5", color:"var(--thm-black)",padding: "5px"}}>1000+ users</h2>
                              <p style={{ fontSize: '16px', lineHeight:"1.5", marginBottom: "10px", color:"var(--thm-black)",padding: "5px"}}>Here's our most recent App Store review</p>
                              <img src="assets/img/golf/app_review.png" />
                          </div>
                      </div>
                  </div>
              </div>
          </section>

        <section className="atf-section-padding" style={{background: 'url(./assets/img/smokebg_white_light_compressed.jpg)', backgroundRepeat: 'no-repeat'}}>
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 align-self-center">
                          <div>
                              <h2 className="heading-size text-center">Tip of the day</h2>
                                        <h4 className="text-center" style={{ fontSize: '24px', margin: '20px 0px 20px 0', fontFamily: 'Comfortaa', lineHeight: '32px' }}>Stop sliding your hips to get more consistency</h4>
                                        <p style={{ fontSize: "16px", lineHeight: "1.7", margin: "5px 0 10px 0"  }}>Moving your hips laterally (sliding) in your backswing causes inconsistency and reduces power.<br /><br />The "Hip slide" analyser measures your hip movement away from the target, so you can practice turning instead of sliding in real-time.</p>
                          
                          </div>
                      </div>
                      <div className="col-lg-4 col-12 text-center">
                        <Carousel
                                swipeable={true}
                                draggable={true}
                                showDots={true}
                                responsive={responsive}
                                infinite={true}
                                autoPlay={true}
                                autoPlaySpeed={8000}
                                keyBoardControl={true}
                                customTransition="transform 300ms ease-in-out"
                                transitionDuration={500}
                                containerClass="carousel-container"
                                dotListClass="custom-dot-list-style"
                                itemClass="carousel-item-padding-40-px"
                            >
                                <div style={{marginBottom: '30px'}}>
                                    <img style={{width:"70%"}} src="./assets/img/golf/lesson_hip_slide_settings.png" alt="Elbow angle" />
                                    <h4 style={{ marginTop: '20px',  fontFamily: 'Comfortaa' }}>Step 1 - Set up</h4>
                                    <div className="px-5" style={{ fontSize: "14px", lineHeight: "1.7", margin: "5px 0 0px 0" }}>
                                        <ol>
                                            <li>Set up your camera front on.</li>
                                            <li>Select "Hip slide" from the analyzer menu.</li>
                                            <li>Set a "Target hip slide" depending on your skill level.</li>
                                        </ol>
                                    </div>
                          
                                </div>

                                <div style={{marginBottom: '30px'}}>
                                    <img style={{width:"70%"}} src="./assets/img/golf/lesson_hip_slide_bad.png" alt="Elbow angle" />
                                        <h4 style={{ marginTop: '20px',  fontFamily: 'Comfortaa' }}>Step 2 - Take a swing</h4>
                                        <div className="px-5" style={{ fontSize: "14px", lineHeight: "1.7", margin: "5px 0 0px 0"  }}>
                                            <ol>
                                            <li>The "Hip slide" analyser measures your hip movement away from the target as a percentage of your hip width.</li>
                                            <li>Aim to get this as small as possible.</li>
                                        </ol>
                                        </div>
                                </div>
                                <div style={{marginBottom: '30px'}}>
                                    <img style={{width:"70%"}} src="./assets/img/golf/lesson_hip_slide_good.png" alt="Elbow angle" />
                                        <h4 style={{ marginTop: '20px', fontFamily: 'Comfortaa' }}>Step 3 - Learn, improve, repeat</h4>
                                        <div className="px-5" style={{ fontSize: "14px", lineHeight: "1.7", margin: "5px 0 0px 0"}}>
                                            <ol>
                                            <li>Practice turning your trail hip back instead of swaying away from the target.</li>
                                            <li>Keep using PracticeLoop to get instant feedback on your progress.</li>
                                        </ol></div>
                                </div>
                            </Carousel>

                          
                          
                      </div>
                  </div>
              </div>
          </section>

          <LoopExplainerSection action="Swing" />

        <PromoBestWayToTry promo={promo} />

        <BottomCallToAction promo={promo} onClick={() => iphoneGolfStore(`${sportKey}_video_bottom_cta`)} />

        </div>
    );
}
